import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                                <section>
                                    <div className="">
                                        <div className="ilead-rgt task">
                                            <div className="innerpadding">


                                                <div className="ilead-contentarea">


                                                    <div className="circle_title-first"><img
                                                        src={require('@images/Browndot.png')}
                                                        alt=""/>PLANNING A TASK EFFECTIVELY</div>
                                                    <p>Although you can learn how to plan, you may not realise that
                                                        there are predictable, psychological
                                                        processes which will affect the process. Understanding these
                                                        processes will greatly assist you to
                                                        deliver consistently. Two of them are described below:</p>
                                                    <div className="lightgreencontentbg keyquestionpad  uiheading">
                                                        <div className="border_subtitle">Never underestimate what you
                                                            think is unimportant
                                                        </div>
                                                        <p>When planning a project we have a natural tendency to pay
                                                            attention to obvious requirements.
                                                            These are things that will be time consuming and/or
                                                            important. As a result, they are uppermost
                                                            in our minds. However, the opposite is also true. We will
                                                            naturally underestimate the impact of
                                                            small or seemingly unimportant demands on our time. Examples
                                                            include unexpected requests
                                                            from clients or colleagues, dealing with administrative
                                                            tasks and responding to emails and
                                                            phone messages. These seem unimportant because they’re never
                                                            very prominent in our
                                                            thinking. However, they all add up and can take up a
                                                            significant amount of our available time.
                                                            Think, for example, about the kind of project you estimate
                                                            would take about five days to
                                                            complete. Now, try to remember the last time you had five
                                                            totally free days in which you could
                                                            concentrate on one task, without having to deal with other
                                                            demands or people. Probably never!</p>
                                                    </div>
                                                    <div className="lightgreencontentbg keyquestionpad  uiheading">
                                                        <div className="border_subtitle">Don’t overestimate positive
                                                            self evaluations
                                                        </div>
                                                        <p>We have a natural tendency to overestimate our own abilities.
                                                            As Myers<a className="superscripttext"
                                                                       href="further_info.php?course=300"><sup>2</sup></a> noted:
                                                            ‘On nearly
                                                            any dimension that is both subjective and socially
                                                            desirable, most people see themselves
                                                            as better than average.’ Because planning and completing a
                                                            task is as much art as science,
                                                            our estimates are inherently subjective. In other words, we
                                                            often discover we can’t do
                                                            something as quickly or as well as we thought we could!</p>
                                                    </div>
                                                    <div className="circle_title"><img
                                                        src={require('@images/Browndot.png')}
                                                        alt=""/>STARTING A TASK</div>
                                                    <p>Even those of us who are good at planning tasks effectively often
                                                        find it hard to get started. Most
                                                        people know how to prioritise tasks, but still put off important
                                                        things. Here are another two
                                                        psychological principles that are key to helping you get
                                                        going.</p>
                                                    <div className="border_subtitle">Understanding psychological
                                                        momentum
                                                    </div>
                                                    <p>We are likely to put off a task if we feel we don’t have the
                                                        ‘momentum’ to get started (and we all
                                                        know how easy that is). However, by better understanding how we
                                                        (wrongly) think about
                                                        ‘psychological momentum’, you can avoid this common pitfall.</p>
                                                    <p>The way we think about psychological momentum is similar to the
                                                        way we think about the physical
                                                        momentum of objects.<a className="superscripttext"
                                                                               href="further_info.php?course=300"><sup>3</sup></a> For
                                                        example, there’s the story of the basketball players who were
                                                        told that
                                                        the team they were about to play had previously beaten their
                                                        arch rivals in a tough local derby.
                                                        They predicted that their chances of winning were much less than
                                                        other teams, who were told
                                                        only that the team had won their last match. This is because the
                                                        idea of a ‘tough local derby’ gave
                                                        the team’s psychological momentum greater ‘mass’!</p>
                                                    <p>Similarly, imagine pushing a heavy weight along the ground, then
                                                        losing your momentum. How
                                                        hard do you think it would be to get started again? We tend to
                                                        think progress will be harder after
                                                        we’ve had psychological momentum, but then lost it. For example,
                                                        students were told that a
                                                        woman called Jane was working on a research paper before being
                                                        interrupted by a phone call.</p>
                                                    <p>Students who were told Jane had been focused and ‘on a roll’
                                                        before the call, rated her chances
                                                        of completing the paper after the phone call as much less than
                                                        other students, who’d been told
                                                        Jane was simply working at a steady pace prior to the
                                                        interruption.</p>

                                                    <div className="left-btn">
                                                        <div
                                                            onClick={this.props.handleChangePage('Page2')}
                                                            className="button-next-previous-done task">&lt;&lt; Previous
                                                        </div>
                                                    </div>
                                                    <div className="right-btn">
                                                        <div
                                                            onClick={this.props.handleChangePage('Page4')}
                                                            className="button-next-previous-done task">Next &gt;&gt;</div>
                                                    </div>


                                                </div>

                                            </div>


                                        </div>


                                    </div>
                                </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}